import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { AzureBlobStorageService } from '@app/shared/services/api/azure-blob-storage.service';

@Component({
  selector: 'app-unregistered-error',
  templateUrl: './unregistered.component.html',
  styleUrls: ['./unregistered.component.scss'],
})
export class UnregisteredErrorComponent implements OnInit {
  companyLogo: any;
  dsoEmail = '';

  constructor(private blobStorageService: AzureBlobStorageService) {}

  ngOnInit() {
    this.dsoEmail = environment.companyGroupEmail;
    this.companyLogo = this.blobStorageService.getBlobImageSafeUrl(`${environment.tenant}/assets/header-logo.png`);
  }
}
